/** @file fieldsShapeOf: the shape of `drawable.set` fields for one kind (all optional; no kind, id, facets). */
import type { Drawable } from '@zilo/pose3d-format/types/drawable';
import type { Shape } from '@zilo/pose3d-format/validate/fields/fieldCheck';
import { DRAWABLE_SHAPES } from '@zilo/pose3d-format/validate/shapes/drawableShapes';

const FIXED = new Set(['kind', 'id', 'facets']);

/** Every field of the kind's shape but `kind`, `id` and `facets`, each optional. */
export function fieldsShapeOf(kind: Drawable['kind']): Shape {
  const s = DRAWABLE_SHAPES[kind];
  return { required: {}, optional: Object.fromEntries(Object.entries({ ...s.required, ...s.optional }).filter(([k]) => !FIXED.has(k))) };
}
